// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xpGY","left":"styles_left__3IVi2"};